// extracted by mini-css-extract-plugin
export default {"svg1":"DottedLines_svg1__EueLI","svg2":"DottedLines_svg2__jAA-7","svg3":"DottedLines_svg3__aLQE6"};